<template>
  <div class="row">
    <div class="col-12 d-flex justify-content-center" v-if="account.signature"><img :src="account.signature" class="img-responsive"></div>
    <div class="col">
      <VueSignaturePad id="signature" width="100%" height="300px" ref="signPad" :options="options"/>
      <div class="d-flex justify-content-between mt-3">
          <button type="button" class="rounded-0 btn btn-outline-secondary" @click="clean"><i class="fa fa-trash"></i></button>
          <button type="button" class="rounded-0 btn btn-outline-dark" @click="change"><i class="fa fa-pencil-alt"></i></button>
          <button type="button" class="rounded-0 btn btn-outline-primary" @click="save"><i class="fa fa-check"></i></button>
      </div>
    </div>
    <div class="col">
      <h5 class="mb-2">Fonctionnement</h5>
      <p class="small text-muted mb-2">Vous générez votre signature ici qui sera apposée sur tous vos documents où le besoin se fera senti:</p>
      <ul class="small text-muted pl-4 mb-0">
        <li>Maintenez votre sourrir tout en déplaçant </li>
        <li>En cas d'erreur, effacez puis recommencez</li>
        <li>Vous pouvez changer de couleur avec le bouton <em>Changer</em></li>
        <li>Une fois la signature est bien apposée, valider pour enregistrer</li>
        <li>Vous pouvez à tout moment remodifier en signant à nouveau</li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
name: "Signature",
  props: {account: Object},
  data: () => ({options: {}, loading: false, payload: {}}),
  methods: {
    onSubmit(value) {
      this.loading = true;
      this.$store.dispatch('auth/profile', {...this.account, signature: value})
          .then(() => this.$swat.fire('Mise à jour', 'Votre compte a été mise à jour avec succès.').then(() => this.payload = {}))
          .catch(({data}) => this.$swat.fire('Erreur de Connexion', (data.message || data.error_description) || 'Sauvegarde échouée', 'error'))
          .finally(() => this.loading = false);
    },
    undo() {
      this.$refs.signPad.undoSignature();
    },
    save() {
      const { isEmpty, data } = this.$refs.signPad.saveSignature();
      if(!isEmpty) this.onSubmit(data);
    },
    change() {
      this.options = {
        penColor: "#00f" // "#c0f"
      };
    },
    clean() {
      this.$refs.signPad.clearSignature();
    }
  }
}
</script>

<style scoped>
#signature {
  border: double 3px transparent;
  border-radius: 5px;
  background-image: linear-gradient(white, white),
  radial-gradient(circle at top left, #4bc5e8, #9f6274);
  background-origin: border-box;
  background-clip: content-box, border-box;
}
</style>